<template>
  <el-container>
    <el-aside width="200px">
      <div class="menu">
        <el-menu
          class="el-menu-vertical"
          background-color="#545c64"
          text-color="#fff"
          active-text-color="#ffd04b"
          text-align="left"
          :router="true"
        >
          <el-menu-item index="/manage">
            <span slot="title">
              入司考试管理
            </span>
          </el-menu-item>
          <el-submenu index="2" v-if="show">
            <span slot="title">题库管理</span>
            <el-menu-item index="/manage/questionManage">新人题库管理</el-menu-item>
            <el-menu-item index="/manage/internetQuestionManage">互联网题库管理</el-menu-item>
            <el-menu-item index="/manage/newQuestionManage">险种题库列表</el-menu-item>
          </el-submenu>
          <el-menu-item index="/manage/examOnlineMange" v-if="show">
            <span slot="title">
              险种试卷上线管理
            </span>
          </el-menu-item>
          <el-menu-item index="/manage/paperConfig" v-if="show">
            <span slot="title">试卷配置</span>
          </el-menu-item>
          <!-- <el-menu-item index="/manage/riskExamTotal" v-if="show">
            <span slot="title">险种考试汇总查询</span>
          </el-menu-item> -->
          <el-submenu index="3">
            <span slot="title">考试情况</span>
            <el-menu-item index="/manage/paperDetails">考试明细查询</el-menu-item>
            <el-menu-item index="/manage/examTotal">考试汇总查询</el-menu-item>
            <el-menu-item index="/manage/examSaleTotal">销售人员可售汇总
          </el-menu-item>
          <el-menu-item index="/manage/riskExamTotal">
            险种考试汇总查询</el-menu-item>
          <el-menu-item index="/manage/examSaleQuery">
            销售人员可售清单查询
          </el-menu-item>
          <el-menu-item index="/manage/examSaleAuthorize">
            销售人员授权汇总查询
          </el-menu-item>
          </el-submenu>
            <!-- <el-menu-item index="/manage/examSaleQuery" v-if="show">
            <span slot="title">销售人员可售清单查询</span>
          </el-menu-item> -->
          <el-menu-item index="/home/message">
            <span slot="title">
              返回
            </span>
          </el-menu-item>
        </el-menu>
      </div>
    </el-aside>
    <el-container>
      <el-header height="56px" style="background:#545c64;line-height:50px;color:white;">
        {{ $route.matched[1].props.default.name }}
      </el-header>
      <el-main style="padding:0;overflow-y:scroll;overflow-x:hidden;height:80vh">
        <div class="view">
          <router-view></router-view>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import api from '@/modules/api.js'
export default {
  name: 'Manage',
  data() {
    return {
      activeNames: [],
      show: false
    }
  },
  methods: {},
  mounted() {
    let submitInfo = {
      pid: '4a93cfd2882c4e4d929b43aae9f54e69'
    }
    let that = this
    // 调用接口保存告知数据
    api.getMenuInfo(submitInfo, function(res) {
      if (res.result.isSuccess === true) {
        console.log(123, res)
        if (res.data.menus.children.length == 2) {
          that.show = true
          window.sessionStorage.setItem('show','Y')
        }
      } else {
        that.$toast(res.result.error)
      }
    })
  }
}
</script>
<style scoped>
.background {
  background: #f2f2f2;
}
.aside {
  width: 10%;
}
.el-menu {
  border: 0px;
}
.el-menu-vertical {
  height: 100vh;
}
.menu {
  width: 100%;
  height: auto;
  margin: 0px auto;
  text-align: center;
  background: rgb(84, 92, 100);
}
.view {
  width: 100%;
  float: right;
}
.menu_container {
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/exam/examManage/manage.vue